module.exports = __webpack_public_path__ + "assets/media/app-bar-logo.4d5361ab.svg";